/*eslint-disable*/

import Vue from 'vue'
import VueRouter from 'vue-router'
import routes from './routes'
import store from '../store'
import {i18n} from "@/plugins/vuetify";
import {EventBus} from "@/event-bus";

import { isFeedbackPath } from '@/services/therapyFeedback'

Vue.use(VueRouter)


const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})


router.beforeEach((to, from, next) => {
    // A full navigation starts/stops analytics before a capability URL is rendered.
    if (from.name && isFeedbackPath(to.path) !== isFeedbackPath(from.path)) {
        window.location.assign(to.fullPath)
        return
    }
    if (to.meta.publicFeedback) {
        next()
        return
    }
    if (to.name == 'MainLayout') {
        next('/fa/panel/dashboard')
        return;
    }
    if (store.state.languages.findIndex(item => item == to.params.lang) != -1) {
        store.dispatch('setLocal', to.params.lang)
    } else {
        store.dispatch('setLocal', 'fa')
        // localStorage.setItem('local', 'fa')
    }

    if (to.meta.auth) {
        if (localStorage.getItem('isLoggedIn')) {
            // if (store.getters.getProfile && to.meta.checkRequiredFiled) {
            //     let profile = store.getters.getProfile
            //     // if ((profile.requiredFields.length != 0 || profile.cycles.length == 0) && !profile.leadUser) {
            //     //     next('/fa/onboarding-new')
            //     //     return;
            //     // }
            //     // if (profile.requiredFields.length != 0 && profile.leadUser) {
            //     //     next('/fa/panel/user-onboarding')
            //     //     return;
            //     // }
            // }
            next()
            return;
        } else {
            next('/fa/login')
            return
        }
    }
    if (to.meta.guest) {
        if (localStorage.getItem('isLoggedIn')) {
            const assignTherapist = to.query.assign_therapist;
            if (assignTherapist) {
                // keep therapist assignment when redirecting logged-in users away from guest pages
                localStorage.setItem('assign_therapist', assignTherapist);
            }
            if (to.query.afterLogin) {
                // this.$router.push({name: this.$route.query.afterLogin})
                next({name: to.query.afterLogin, params: {lang: 'fa'}})
                return;
            }

            next('/fa/panel/dashboard')
            return;
        }
    }

    next()
    return
})

export default router
